<template>
  <Modal @close="close()">
    <div
      class="save-modal-body"
      slot="body"
    >
      <div class="save-icon-container">
        <SaveIcon
          :iconColor="'#bb5cee'"
          :width="32"
        />
      </div>
      <h1>Din rute er gemt</h1>
      <p>Du kan dele ruten via linket</p>
      <div
        class="share-url"
        data-title=""
        @click="copyShareUrl"
      >{{shareUrl}}<div class="tool-tip"><span v-if="copying">Kopieret til udklipsholder!</span><span v-else>Klik for at kopiere</span></div>
      </div>

      <div class="save-modal-button-container">
        <button
          class="primary"
          @click="close"
        >OK</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import SaveIcon from '@/components/Icons/Save.vue';
import { copyToClipBoard } from '@/util';
export default {
  name: 'save-modal',
  components: {
    Modal,
    SaveIcon,
  },
  props: {
    id: String,
    close: Function,
  },
  data: function() {
    return {
      copying: false,
      copyToClipBoard,
    };
  },
  computed: {
    shareUrl() {
      const hash =
        process.env.VUE_APP_ROUTER_HISTORY_MODE === 'hash' ? '#/' : '';
      return `${window.location.origin}${process.env.BASE_URL}${hash}view/${
        this.id
      }`;
    },
  },
  methods: {
    copyShareUrl() {
      this.copying = true;
      this.copyToClipBoard(this.shareUrl);
      setTimeout(() => {
        this.copying = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 20px;
}
.modal-header {
  h1 {
    font-size: 15px;
  }
}

table {
  /* font-family: arial, sans-serif; */
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 40px;
}

td,
th {
  text-align: left;
  padding: 8px 0;
}

.table-vejkode-selected {
  td,
  th {
    border-bottom: 1px solid rgba($selected-color, 0.3);
  }
}
.table-vejkode-ny {
  td,
  th {
    border-bottom: 1px solid rgba($default-color, 0.3);
  }
}

.footer {
  margin: -10px -10px 0 0;
}
.vejkode-selected {
  color: $selected-color;
}
.vejkode-ny {
  color: $default-color;
}

.col-vejkode {
  width: 110px;
}

textarea {
  background-color: rgba(121, 56, 208, 0.05);
  font-family: 'Open Sans', 'sans-serif';
  font-size: 16px;
  width: 100%;
  border: 1px solid #e7ebfa;
  border-radius: 2px;
  padding: 8px 14px;
  min-height: 80px;
}
textarea:focus {
  background-color: #ffffff;
  outline: 1px solid $default-color;
}

.danger {
  color: $danger-color;
}
.share-url {
  background-color: #f5e7fd;
  padding: 8px 12px;
  cursor: pointer;
  transition: 0.2s;
  position: relative;
  margin: 0 40px;
}

.share-url:hover {
  color: #9900ea;
}
.tool-tip {
  // bottom: -1.5em;
  bottom: -2em;
  left: 50%;
  transform: translateX(-50%);
}
.share-url:hover .tool-tip {
  // opacity: 1;
  // transition: all 0.3s ease 0.3s;
  // visibility: visible;
  display: block;
}

.save-modal-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.save-icon-container {
  margin-top: 20px;
  background-color: rgba(187, 92, 238, 0.145);
  height: 70px;
  width: 70px;
  border-radius: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
h1 {
  font-weight: 700;
  font-size: 24px;
  color: #0f1c70;
  margin: 18px 0;
}

.save-modal-button-container {
  margin: 30px 40px 60px 40px;
}

button {
  background-color: #adb1ce;
  color: #ffffff;
  border: none;
  border-radius: 3px;
  padding: 0;
  font: inherit;
  cursor: pointer;
  width: 130px;
  height: 42px;
  margin: 6px;
  font-weight: 600;
  &:hover {
    box-shadow: 0 2px 10px 0 #0f1c7040;
  }
}
.primary {
  background-color: #0f1c70;
}

@media only screen and (max-width: $mobile-max-width) {
  .share-url {
    margin: 0 30px;
  }

  .save-modal-button-container {
    margin: 20px 0 40px 0;
  }
}
</style>
